document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-nf-cart-drawer]');
  if (!drawer) return;
  const itemsEl = drawer.querySelector('[data-nf-cart-items]');
  const emptyEl = drawer.querySelector('[data-nf-cart-empty]');
  const reviewsEl = drawer.querySelector('[data-nf-cart-reviews]');
  const totalEl = drawer.querySelector('[data-nf-cart-total]');
  const errorEl = drawer.querySelector('[data-nf-cart-error]');
  const checkoutEl = drawer.querySelector('[data-nf-cart-checkout]');
  const shippingEl = drawer.querySelector('[data-nf-cart-shipping]');
  const progress = drawer.querySelector('[data-nf-progress]');
  const progressTrack = drawer.querySelector('[data-nf-progress-track]');
  const progressFill = drawer.querySelector('[data-nf-progress-fill]');
  const shippingThreshold = Number(drawer.dataset.freeShippingThreshold || 0);
  const shippingFee = { AT: 590, DE: 690, IT: 1290, LU: 2690 }[drawer.dataset.shippingCountryCode];
  const shippingCountry = drawer.dataset.shippingCountry || '';
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-AT', { style: 'currency', currency: 'EUR' });
  let busy = false;
  const setBusy = (value) => {
    busy = value;
    itemsEl.setAttribute('aria-busy', String(value));
    itemsEl.querySelectorAll('button').forEach((button) => { button.disabled = value; });
  };
  const money = (cents) => formatter.format((Number(cents) || 0) / 100);
  const fetchCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Warenkorb konnte nicht geladen werden.');
    return response.json();
  };
  const updateCounts = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  };
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const render = (cart) => {
    itemsEl.replaceChildren();
    const gift = drawer.querySelector('[data-nf-ebook-gift]');
    if (gift) {
      const count = (cart.items || []).reduce((sum, item) => sum + (String(item.product_id) === gift.dataset.giftProductId ? Number(item.quantity) : 0), 0);
      gift.hidden = count < 3 || gift.dataset.giftCountry !== 'true';
    }
    emptyEl.hidden = cart.item_count > 0;
    if (reviewsEl) reviewsEl.hidden = cart.item_count === 0;
    totalEl.textContent = money(cart.total_price);
    const original = Number(cart.original_total_price || 0);
    const savings = Math.max(0, original - Number(cart.total_price || 0));
    const breakdown = drawer.querySelector('[data-nf-cart-breakdown]');
    breakdown.replaceChildren(); breakdown.hidden = savings <= 0;
    const addRow = (label, value, className = '') => {
      const row = node('div', 'nf-cart-breakdown__row ' + className);
      row.append(node('span', '', label), node('strong', '', value)); breakdown.append(row);
    };
    if (savings > 0) {
      addRow('Warenwert vor Rabatten', money(original), 'nf-cart-breakdown__original');
      const grouped = new Map();
      (cart.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => {
        const title = allocation.discount_application?.title || 'Mengenrabatt';
        grouped.set(title, (grouped.get(title) || 0) + Number(allocation.amount || 0));
      }));
      (cart.cart_level_discount_applications || []).forEach(discount => {
        grouped.set(discount.title, (grouped.get(discount.title) || 0) + Number(discount.total_allocated_amount || 0));
      });
      grouped.forEach((amount, title) => { if (amount > 0) addRow(title, '−' + money(amount)); });
      addRow('Du sparst insgesamt', money(savings), 'nf-cart-breakdown__saving');
    }
    const appliedCodes = drawer.querySelector('[data-nf-applied-codes]');
    appliedCodes.replaceChildren();
    (cart.discount_codes || []).forEach(discount => {
      const chip = node('span', 'nf-cart-code-chip');
      chip.append(node('span', '', discount.code + (discount.applicable ? '' : ' · nicht anwendbar')));
      const remove = node('button', '', '×'); remove.type = 'button';
      remove.setAttribute('aria-label', 'Rabattcode ' + discount.code + ' entfernen');
      remove.addEventListener('click', async () => {
        remove.disabled = true;
        const status = drawer.querySelector('[data-nf-discount-status]');
        try {
          const nextCodes = (cart.discount_codes || []).filter(item => item.code !== discount.code).map(item => item.code).join(',');
          const updated = await setDiscountCodes(nextCodes); render(updated);
          status.textContent = 'Rabattcode entfernt.';
        } catch { status.textContent = 'Code konnte nicht entfernt werden. Bitte erneut versuchen.'; remove.disabled = false; }
      });
      chip.append(remove); appliedCodes.append(chip);
    });
    checkoutEl.hidden = cart.item_count === 0;
    const supportedCart = (cart.items || []).every(item => item.handle === 'nufeelia' || Number(item.variant_id) === 59554582495564);
    const remaining = Math.max(0, shippingThreshold - Number(cart.total_price || 0));
    const showProgress = cart.item_count > 0 && supportedCart && shippingThreshold > 0;
    if (shippingEl) {
      shippingEl.hidden = cart.item_count === 0;
      if (!shippingEl.hidden) {
        shippingEl.textContent = shippingFee === undefined || !supportedCart
          ? `Versand nach ${shippingCountry}: Berechnung im Checkout.`
          : showProgress
            ? remaining === 0
              ? `Kostenloser Versand nach ${shippingCountry} freigeschaltet.`
              : `Noch ${money(remaining)} bis zum kostenlosen Versand nach ${shippingCountry}.`
            : `Versand nach ${shippingCountry}: ${money(shippingFee)}.`;
      }
    }
    progress.hidden = !showProgress;
    if (showProgress) {
      const percent = Math.min(100, Math.max(0, Number(cart.total_price) / shippingThreshold * 100));
      progressTrack.setAttribute('aria-valuenow', String(Math.round(percent)));
      progressTrack.setAttribute('aria-valuetext', remaining === 0 ? 'Gratisversand erreicht' : `${money(remaining)} bis zum Gratisversand`);
      progressFill.style.width = `${percent}%`;
      progress.classList.toggle('is-complete', remaining === 0);
    }
    drawer.querySelector('[data-nf-countdown]').hidden = !cart.item_count || (countdownEnd > 0 && countdownEnd <= Date.now());
    updateCounts((cart.items || []).filter(item => Number(item.variant_id) !== 59554582495564).reduce((n,item)=>n+item.quantity,0));
    (cart.items || []).filter(item => Number(item.variant_id) !== 59554582495564).forEach((item) => {
      const row = node('article', 'nf-cart-drawer__item');
      if (item.image) {
        const img = node('img');
        img.src = item.image;
        img.alt = item.product_title || 'Nufeelia';
        img.loading = 'lazy';
        row.append(img);
      } else {
        row.append(node('span'));
      }
      const detail = node('div');
      detail.append(node('h3', '', item.product_title || 'Nufeelia'));
      if (item.variant_title && item.variant_title !== 'Default Title') detail.append(node('p', '', item.variant_title));
      const controls = node('div', 'nf-cart-drawer__quantity');
      const minus = node('button', '', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', `${item.variant_title || item.product_title} verringern`);
      const number = node('span', '', String(item.quantity));
      const plus = node('button', '', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', `${item.variant_title || item.product_title} erhöhen`);
      minus.addEventListener('click', () => changeQuantity(item.key, item.quantity - 1));
      plus.addEventListener('click', () => changeQuantity(item.key, item.quantity + 1));
      controls.append(minus, number, plus);
      detail.append(controls);
      const price = node('div', 'nf-cart-drawer__line-price');
      if (item.original_line_price > item.final_line_price) price.append(node('s', '', money(item.original_line_price)));
      price.append(node('strong', '', money(item.final_line_price)));
      if (item.quantity > 0 && item.product_id === 16115999998284) {
        detail.append(node('p', 'nf-cart-drawer__unit-price', money(item.final_line_price / item.quantity) + ' / Packung · ' + money(item.final_line_price / item.quantity / 10) + ' / Mahlzeit'));
      }
      row.append(detail, price);
      itemsEl.append(row);
    });
  };
  const showError = (message) => {
    errorEl.textContent = message;
    errorEl.hidden = !message;
  };
  const changeQuantity = async (key, quantity) => {
    if (busy) return;
    setBusy(true);
    showError('');
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
      });
      if (!response.ok) throw new Error('Menge konnte nicht geändert werden.');
      const updated = await response.json();
      render(window.NufeeliaEbookGift ? await window.NufeeliaEbookGift.sync() : updated);
    } catch (error) {
      showError(error.message || 'Bitte erneut versuchen.');
    } finally {
      setBusy(false);
    }
  };
  let countdownEnd = 0;
  let countdownInterval;
  const startCountdown = () => {
    if (!countdownEnd) countdownEnd = Date.now() + 360000;
    clearInterval(countdownInterval);
    const update = () => {
      const seconds = Math.max(0, Math.ceil((countdownEnd - Date.now()) / 1000));
      drawer.querySelector('[data-nf-countdown-time]').textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      if (!seconds) { clearInterval(countdownInterval); drawer.querySelector('[data-nf-countdown]').hidden = true; }
    };
    update(); countdownInterval = setInterval(update, 1000);
  };
  const setDiscountCodes = async codes => {
    const response = await fetch('/cart/update.js', { method: 'POST', headers: {'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({discount:codes}) });
    if (!response.ok) throw new Error('Rabattcode konnte nicht geändert werden.');
    const cart = await response.json();
    return window.NufeeliaEbookGift ? window.NufeeliaEbookGift.sync() : cart;
  };
  drawer.querySelector('[data-nf-discount-form]').addEventListener('submit', async event => {
    event.preventDefault();
    const form = event.currentTarget, code = form.elements.discount.value.trim();
    const status = form.querySelector('[data-nf-discount-status]');
    if (!code) { status.textContent = 'Bitte einen Code eingeben.'; return; }
    const button = form.querySelector('button'); button.disabled = true;
    try {
      const current = await fetchCart();
      const previousCode = (current.discount_codes || []).find(item => item.applicable)?.code || '';
      let cart = await setDiscountCodes(code);
      const applied = (cart.discount_codes || []).some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
      if (!applied) cart = await setDiscountCodes(previousCode);
      render(cart);
      status.textContent = applied
        ? (previousCode && previousCode.toLowerCase() !== code.toLowerCase() ? 'Rabattcode ersetzt.' : 'Rabattcode angewendet.')
        : 'Dieser Code ist nicht anwendbar.' + (previousCode ? ' Dein bisheriger Code bleibt erhalten.' : '');
      if (applied) form.elements.discount.value = '';
    } catch { status.textContent = 'Code konnte nicht geprüft werden. Bitte erneut versuchen.'; }
    finally { button.disabled = false; }
  });
  const open = async (cart) => {
    showError('');
    if (!drawer.open) drawer.showModal();
    drawer.querySelector('[data-nf-cart-close]')?.focus();
    try { render(window.NufeeliaEbookGift ? await window.NufeeliaEbookGift.sync() : (cart || await fetchCart())); startCountdown(); }
    catch (error) { showError(error.message || 'Warenkorb konnte nicht geladen werden.'); }
  };
  const close = () => { if (drawer.open) drawer.close(); };
  window.NufeeliaCartDrawer = { open, close };
  drawer.querySelectorAll('[data-nf-cart-close]').forEach((button) => button.addEventListener('click', close));
  drawer.addEventListener('click', (event) => { if (event.target === drawer) close(); });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== '/cart') return;
    event.preventDefault();
    open();
  });
});

